import 'bootstrap-3-typeahead';

$(document).ready(function () {
		
	//fake navigation links
	$('span.nav-link').click(function(event){
		event.preventDefault();
		window.location = $(this).attr("data-href");
	});
	            
	var path = baseUrl + "/autocomplete";
	
	$(function () {
		$('[data-toggle="tooltip"]').tooltip();
	})
	
	$( "body" ).on( "click", ".a-la-une",function( event ) {	
		event.preventDefault();	
		location.href= $(this).attr("data-url");
	});
	
	$( "body" ).on( "click", ".search a",function( event ) {	
		event.preventDefault();	
		$("#frmSearch").submit();
	});
	
	$( "body" ).on( "click", ".show-image",function( event ) {	
		event.preventDefault();	
		
		$('#lg-image').attr('src',$(this).attr('data-thumbnail'));
		$('#imageModal').modal('show');
	});
	
	$('input.typeahead').typeahead({
		source: function (query, process) {
			$.ajax({
				url: path,
				type: "POST",
				data: 'q='+query,
				dataType: 'JSON',
				async: true,
				success: function(data){
				   var resultList = data.map(function (item) {
					   var link = { href: baseUrl + '/'+ item.href, name: item.name };
						   return JSON.stringify(link);					  
						 });
						return process(resultList);
				}
			})
		},	
				
		highlighter: function (link) {		
			var item = JSON.parse(link);		
			var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
			return item.name.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
				return '<strong>' + match + '</strong>'
			})
		},
		updater: function (link) {
		   var item = JSON.parse(link);       
		   location.href=item.href;       
		}
	});	
			
	$( "body" ).on( "click", "#get-group-devices",function( event ) {	
		event.preventDefault();			
		$.ajax({
			data: $("#frm-groups").serialize(),
			url: baseUrl+'/get_group_devices',
			type: "post",
			dataType: "json",
			success: function (data) {	
				$(".breadcrumb-group").toggle();
				$("#intro").hide();
				$("#slides").hide();
			
				show_offers(data['offers']);
			
			},
			error: function (data) {
				
			}
		});
	});
	
	$( "body" ).on( "click", ".select-group-devices",function( event ) {		
		event.preventDefault();		
		$("#single-group").val($(this).attr('data-id'));
		$.ajax({
			data: $("#frm-groups").serialize(),
			url: baseUrl+'/get_group_devices',
			type: "post",
			dataType: "json",
			success: function (data) {	
				$("#slides").html(data['devices']);	
				show_offers(data['offers'], true);
				
			},
			error: function (data) {
				
			}
		});
	});
	
	
	$( "body" ).on( "click", "#get-devices",function( event ) {			
		event.preventDefault();				
		
		if (!$('input[name="devices[]"]:checked').length) return; 
		
		$.ajax({
			data: $("#frm-devices").serialize(),
			url: baseUrl+'/get_devices',
			type: "post",
			dataType: "json",
			success: function (data) {				
				$("#intro").hide();
				$("#slides").hide();
				show_offers(data['offers']);
			},
			error: function (data) {
				
			}
		});
	});
		
	//Make sure blocks are squared
	$('.slide .block').css('height', $('.slide .block').css('width') );
	$(window).on('resize', function(){
		$('.slide .block').css('height', $('.slide .block').css('width') );
	});
	
	$( "body" ).on( "click", ".next-slide",function( event ) {	
		event.preventDefault();
		var target = parseInt($(this).attr('data-target'));
		var max = parseInt($(this).attr('data-max'));
		
		$('.slide').removeClass('active');
		$('#slide-'+target).addClass('active');
		
		$('.my-progress').removeClass('active');
		$('#progress-'+target).addClass('active');
		
		if (target-1>0) $('.previous-slide').attr('data-target', target-1);
		else $('.previous-slide').attr('data-target', max);
			
		if (target<max) $(this).attr('data-target', target+1);			
		else $(this).attr('data-target', 1);	
		
		
	});
	
	$( "body" ).on( "click", ".previous-slide",function( event ) {	
		event.preventDefault();
		var target = parseInt($(this).attr('data-target'));
		var max = parseInt($(this).attr('data-max'));
		
		$('.slide').removeClass('active');
		$('#slide-'+target).addClass('active');
		
		$('.my-progress').removeClass('active');
		$('#progress-'+target).addClass('active');
				
		if (target+1<=max) $('.next-slide').attr('data-target', target+1);
		else $('.next-slide').attr('data-target', 1);
		
		if (target>1) $(this).attr('data-target', target-1);
		else $(this).attr('data-target', max);	
			
	});
	
	$( "body" ).on( "click", ".nav-slide",function( event ) {	
		event.preventDefault();
		var target = parseInt($(this).attr('data-target'));
		var max = parseInt($(this).attr('data-max'));
		
		$('.slide').removeClass('active');
		$('#slide-'+target).addClass('active');
		
		$('.my-progress').removeClass('active');
		$(this).parent().addClass('active');
		
		if (target-1>0) $('.previous-slide').attr('data-target', target-1);
		else $('.previous-slide').attr('data-target', max);
		
		if (target+1<=max) $('.next-slide').attr('data-target', target+1);
		else $('.next-slide').attr('data-target', 1);
			
	});
	
	$( "body" ).on( "click", "#slides .multi-select .block",function( event ) {	
		$(this).toggleClass('selected');
		var check = $(this).find('input:checkbox');
        check.prop("checked", !check.prop("checked"));
		$('html,body').animate({scrollTop: $("#intro").offset().top},'slow');
	});
	
	$( "body" ).on( "change", "#slides .multi-select .block input:checkbox",function( event ) {
		if(this.checked) $(this).parent().parent().parent().addClass('selected');	//change this use find !!
		else $(this).parent().parent().parent().removeClass('selected');
		$('html,body').animate({scrollTop: $("#intro").offset().top},'slow');
	});
	
	$( "body" ).on( "click", "#slides .single-group-select .block",function( event ) {	
		
		event.preventDefault();			
		
		$("#single-group").val($(this).attr('data-id'));
		
		$.ajax({
			data: $("#frm-groups").serialize(),
			url: baseUrl+'/get_group_devices',
			type: "post",
			dataType: "json",
			success: function (data) {	
				$("#intro").hide();
				$("#slides").hide();
				$("#conditions").show();
				//$("#slides").html(data['devices']);
				//$(".breadcrumb-group").toggle();
			},
			error: function (data) {
				
			}
		});
	});
	
	$( "body" ).on( "click", "#slides .single-device-select .block",function( event ) {	
		
		event.preventDefault();	
		
		$("#single-device").val($(this).attr('data-id'));
		
		$.ajax({
			data: $("#frm-devices").serialize(),
			url: baseUrl+'/get_devices',
			type: "post",
			dataType: "json",
			success: function (data) {	
				$("#intro").hide();
				$("#slides").hide();
				$("#conditions").show();
				//$("#slides").html(data['devices']);
				//$(".breadcrumb-group").toggle();
			},
			error: function (data) {
				
			}
		});
	});
	
	$( "body" ).on( "click", "#slides .vmm-group-select .block",function( event ) {			
		event.preventDefault();
		$("#vmm-group").val($(this).attr('data-id'));
		
		$.ajax({
			data: $("#frm-devices").serialize(),
			url: baseUrl+'/get_devices',
			type: "post",
			dataType: "json",
			success: function (data) {					
				$("#intro").hide();
				$("#slides").hide();
				$("#conditions").show();
			},
			error: function (data) {
				
			}
		});
	});
	
	
	
	function getDevicesOffers(){
		$.ajax({
			data: $("#frm-groups").serialize(),
			url: baseUrl+'/get_devices',
			type: "post",
			dataType: "json",
			success: function (data) {	
				
				$("#conditions").hide();
				$("#tuning").show();
				show_offers(data['offers']);
				
				if ($(window).width()<991){
					$(".no-tuning").hide();
					$("#dropdowns").hide();
					$("#offers_block").hide();
					$("#offers").css("background-color", "#ffffff");
					$("#filters-block").show();
				}
				
				
				
			},
			error: function (data) {
				
			}
		});
	}
	
	$("body").on('click', '.add-favorite', function(event){
		event.preventDefault(); 
		$.ajax({
			url: baseUrl+"/add_to_favorites",
			type:"POST",
			data:{
				offer_id: $(this).attr('data-offer-id'),
			},
			success:function(response){
				console.log(response);
			  
			},
			 statusCode: {
				200: function() {
				  $.notify("L'offre a bien été ajoutée à vos favoris.", "info");
				},
				401: function() {
				  $("#loginModal").modal('show');
				}
			 },
		});
	});
	
	$("body").on('click', '.add-alert', function(event){
		event.preventDefault(); 
		
		$("#alert-price-wish").val("");
		$("#alert-offer-id").html($(this).attr('data-offer-id'));
		$("#alert-current-price").html($(this).attr('data-price')+' €');
		$("#alert-device").html($(this).attr('data-device'));
		$("#alert-condition").html($(this).attr('data-condition'));
		$("#alertModal").modal('show');
	});
	
	$("body").on('click', '#add-alert-action', function(event){
		event.preventDefault(); 
		$.ajax({
			url: baseUrl+"/add_to_alerts",
			type:"POST",
			data:{
				offer_id: $("#alert-offer-id").html(),
				condition: $("#alert-condition").html(),
				price_wish:$("#alert-price-wish").val().replace(/[^\d,-]/g, '').replace(",", '.'),
			},
			success:function(response){
				console.log(response);
			  
			},
			 statusCode: {
				200: function() {
					$("#alertModal").modal('hide');
					$.notify("L'alerte a bien été ajoutée.", "info");
				},
				401: function() {
					$("#alertModal").modal('hide');
					$("#loginModal").modal('show');
				}
			 },
		});
	});
	
	$("#ajax-register").click(function(event){
		event.preventDefault();
		$("#status").html("");
		$.ajax({
			url: baseUrl+"/register",
			type:"POST",
			data:$("#frmRegister").serialize(),
			success:function(response){
			},
			statusCode: {
				200: function() {
					$("#frmRegister")[0].reset();
					$("#status").html('<div class="alert alert-info">Votre compte a été créé avec succès. Un mail de confirmation vous a été envoyé.</div>');
					$("#register-modal").hide();
					$("#login-modal").show();
				},
				422: function(response) {
					
					var errors="";
					for (var error in response.responseJSON['errors']) {
						errors=errors+response.responseJSON['errors'][error] + '<br>';
					}				
					$("#status").html('<div class="alert alert-danger">'+errors+'</div>');
				}
			 },
		});
	});
	
	$("#ajax-login").click(function(event){
		event.preventDefault();
		$("#status").html("");
		$.ajax({
			url: baseUrl+"/login",
			type:"POST",
			data:$("#frmLogin").serialize(),
			success:function(response){
				console.log(response);
			},
			statusCode: {
				200: function(response) {
					//success
					reset_token(response['csrf']);
					$("#frmLogin")[0].reset();
					$("#status").html('<div class="alert alert-info">Vous êtes connecté.</div>');
					$(".guest").hide();$(".logged").show();
					setTimeout(function() {$('#loginModal').modal('hide');}, 2000);
				},
				499:function(response) {
					//account not confirmed
					reset_token(response.responseJSON['csrf']);					
					$("#status").html('<div class="alert alert-danger">Votre compte n\'est pas encore confirmé. Veuillez cliquer sur le lien reçu par email.</div>');
				},
				498:function(response) {
					//user deactived				
					$("#status").html('<div class="alert alert-danger">Votre compte a été désactivé.</div>');
				},
				422: function(response) {
					//general error (validation...)
					var errors="";
					for (var error in response.responseJSON['errors']) {
						errors=errors+response.responseJSON['errors'][error] + '<br>';
					}				
					$("#status").html('<div class="alert alert-danger">'+errors+'</div>');
				}
			 },
		});
	});
	
	function reset_token(token){
		$('meta[name="csrf-token"]').attr('content', token);					
		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});
	}
		
	function get_groups_by_brand(){
		$(".select-group").not(':first').remove();
		$(".select-device").not(':first').remove();
		$("#devices-groups").html('<option selected disabled>Sélectionner un modèle</option>');	
		$.ajax({
			data: $("#frm-select").serialize(),
			url: baseUrl+'/get_groups_by_brand',
			type: "post",
			dataType: "json",
			success: function (data) {
				data['devices_groups'].forEach(function(obj) { 					
					$("#devices-groups").append('<option value="'+obj.id+'">'+obj.name+'</option>');					
				});
				$(".select-group").prop("disabled",false);	
				$(".select-device").prop("disabled",false);	
				$(".compare").prop("disabled",false); 
				$(".reset").prop("disabled",false); 
				$("#offers").html(data['offers']);				
			},
			error: function (data) {
				
			}
		});
	}
	
	
	$("body").on('change', '.select-group', function(event){
		event.preventDefault();	
		$(this).clone().appendTo( "#devices-groups-wrapper" );
		$(".select-group:last").find(':selected').text("Ajouter un modèle");
		
	});
	
	$("body").on('change', '.select-device', function(event){
		$("#group-id").val($(this).find(':selected').val());
		$("#devices").find('option').not(':first').remove();
		$.ajax({
			data: $("#frm-select").serialize(),
			url: baseUrl+'/get_devices_by_group',
			type: "post",
			dataType: "json",
			success: function (data) {	
				if (data['devices'].length==1){
					$("#device-slug").val(data['devices'][0].href);	
					$('.prepare-device').prop("disabled",false); 
				}else{
					data['devices'].forEach(function(obj) { 					
						$("#devices").append('<option data-slug="'+obj.href+'" value="'+obj.id+'">'+obj.name+'</option>');
						$("#devices").show();
					});
				}
			},
			error: function (data) {
				
			}
		});
	});
	
	$("body").on('change', '.check-device', function(event){
		$("#device-slug").val($(this).find(':selected').attr('data-slug'));	
		$('.prepare-device').prop("disabled",false); 
	});
		
	$("body").on('click', '.compare', function(event){
		event.preventDefault();		
		$.ajax({
			data: $("#frm-select").serialize(),
			url: baseUrl+'/get_groups_by_brand',
			type: "post",
			dataType: "json",
			success: function (data) {					
				
				show_offers(data['offers']);
				$("#dropdowns").hide();



				
			},
			error: function (data) {
				
			}
		});
	});
			
	$("body").on('click', '.prepare-device', function(event){
		event.preventDefault();
		location.href = baseUrl+'/'+$("#device-slug").val();
	});
	
	$("body").on('click', '.reset', function(event){
		event.preventDefault();	
		$(".select-group").not(':first').remove();
		$(".select-group").val($(".select-group option:first").val());
	});
	
	$("body").on('click', '.modify-device', function(event){
		event.preventDefault();	
		scrollTo("#offers");
		//$('#offers').animate({ scrollTop: 0 }, 'slow');
		$(".no-tuning").hide();
		
		$("#offers_block").hide();
		$("#filters-block").hide();
		$("#dropdowns").show();
	});
		
		
});

